// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Scrollbar, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import './_collection-list.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--collection-list").each(function(index, element){
    var $this = $(this);
    const enableChevron = $this.attr("data-chevron"),
          navigation = (enableChevron == 'true') ? {
            nextEl: ".collection-list-btn-next-" + index,
            prevEl: ".collection-list-btn-prev-" + index
          } : {},
          mobileSlidesPerview = (enableChevron == 'true') ? 1 : 1.2;

    // Generate unique class for each feature collection slider
    $this.addClass("collection-list-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.collection-list').find(".swiper-scrollbar").addClass("collection-list-swiper-scrollbar-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.collection-list').find(".swiper-button-next").addClass("collection-list-btn-next-" + index);
    $this.parents('.collection-list').find(".swiper-button-prev").addClass("collection-list-btn-prev-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".collection-list-instance-" + index, {
        // Optional parameters
        modules: [Navigation, Scrollbar, A11y],
        slidesPerView: mobileSlidesPerview,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },

        scrollbar: {
            el: ".collection-list-swiper-scrollbar-" + index,
            draggable: true,
        },

        navigation: navigation
    });

    // swiper.slides.forEach(function(slide, index) {
    //     let slideLink = slide.querySelector('a');
    //     slideLink.addEventListener('focus', function(e) {
    //         swiper.slideTo(index);
    //     })
    // });
  });
});
